import zxcvbn from 'zxcvbn';

/**
 * Check password is strong.
 *
 * @param {string} value Password to check.
 *
 * @returns {boolean} Is strong.
 */
export function isStrongPassword(value: string): boolean {
  const { score } = zxcvbn(value);
  return score >= 2;
}
